/**
 * AdvantagesSection — eyebrow + heading + one big card.
 * Path: advantages.{eyebrow, heading, cardTitle, cardBody}
 */

import { BilingualTextField, BilingualTextareaField, SectionPanel } from '../fields/BilingualFields'

export default function AdvantagesSection({ getField, setField }) {
  return (
    <SectionPanel title="Advantages" subtitle="How families benefit — single big card">
      <BilingualTextField label="Eyebrow" path="advantages.eyebrow" getField={getField} setField={setField} />
      <BilingualTextField label="Section heading" path="advantages.heading" getField={getField} setField={setField} />
      <BilingualTextField label="Card title" path="advantages.cardTitle" getField={getField} setField={setField} />
      <BilingualTextareaField label="Card body" path="advantages.cardBody" getField={getField} setField={setField} rows={5} />
    </SectionPanel>
  )
}
